import { useGetOrganizationId } from './useGetOrganizationId';
import { useGetIntegrationUsageQuery } from '@/redux/slices/integrationsApiSlice';

/**
 * Whether the organisation has reached its connected-application limit.
 *
 * Both the connected count and the limit come from the `/integrations/usage`
 * endpoint, which is the source of truth. Returns `false` when no limit is
 * enforced (or usage hasn't loaded yet).
 */
export const useIsAppLimitReached = (): boolean => {
  const organizationId = useGetOrganizationId();
  const { data: usage } = useGetIntegrationUsageQuery(organizationId);

  if (
    usage?.applicationsLimit === null ||
    usage?.applicationsLimit === undefined
  )
    return false;

  return usage.connectedCount >= usage.applicationsLimit;
};
